import React from "react";
import { Form } from "@redriver/cinnamon";
import { ColumnGrid } from "components/containers";
import { YesNoRadioField } from "components/forms";
import TabLockedMessage from "./TabLockedMessage";
import { useSelector } from "react-redux";
import { getCurrentStepLocked } from "./selectors";

const MedicalForm = () => {
  const isLocked = useSelector(getCurrentStepLocked);
  return (
    <ColumnGrid cols={2}>
      <ColumnGrid.Item>
        <YesNoRadioField
          field="hasMedicalRequirements"
          label="Does the passenger have medical/dietary requirements?"
          required
          disabled={isLocked}
        />
      </ColumnGrid.Item>
      <Form.If
        condition={({ fields }) => fields.hasMedicalRequirements == true}
      >
        <ColumnGrid.Item>
          <Form.Input
            field="dietaryRequirements"
            label={
              <label>
                Dietary Requirements <br />
                If you have no dietary requirements, please leave blank
              </label>
            }
            fluid
            disabled={isLocked}
          />
        </ColumnGrid.Item>
        <ColumnGrid.Item>
          <YesNoRadioField
            field="epipenCarrier"
            label="Epipen Carrier?"
            required
            disabled={isLocked}
          />
        </ColumnGrid.Item>
        <ColumnGrid.Item>
          <Form.Input
            field="medicalRequirements"
            label={
              <label>
                Medical Requirements <br />
                If you have no medical requirements, please leave blank
              </label>
            }
            fluid
            disabled={isLocked}
          />
        </ColumnGrid.Item>
        <ColumnGrid.Item colsWidth={2}>
          <p>
            By providing medical/dietary information,
            parents/carers/participants acknowledge that whilst all reasonable
            steps will be taken to communicate these requirements and request
            appropriate provisions, Select School Travel and its suppliers
            cannot guarantee that all medical/dietary requirements can be met.
            In addition, establishments may have a single kitchen or food
            preparation area, meaning that we cannot guarantee that food will be
            free of traces of specific allergens due to cross contamination.
          </p>
          <p>
            Parents/carers/group members are therefore advised to discuss any
            medical/dietary requirements or food allergies with the group leader{" "}
            <strong>as far in advance of the trip as possible</strong>,
            particularly where a participant has a severe or potentially
            life-threatening allergy or condition. The group leader can then
            clarify the arrangements with Select School Travel and the relevant
            suppliers before departure and discuss any additional precautions or
            provisions that may be necessary.
          </p>
        </ColumnGrid.Item>
      </Form.If>
      {isLocked && (
        <ColumnGrid.Item colsWidth={2}>
          <TabLockedMessage />
        </ColumnGrid.Item>
      )}
    </ColumnGrid>
  );
};

export default MedicalForm;
